if (!customElements.get('slipi-cart-delivery')) {
  customElements.define('slipi-cart-delivery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const items = JSON.parse(this.querySelector('[data-delivery-items]').textContent);
      const unknown = this.querySelector('[data-delivery-unknown]').textContent;
      const money = value => `${new Intl.NumberFormat('he-IL', { maximumFractionDigits: 2 }).format(value)} ₪`;
      const rows = [];
      const groups = { beds: [], mattresses: [], stands: [], wardrobes: [], gallery: [], other: [] };
      const firstCost = item => {
        const source = [item.cost].flat().filter(Boolean).join(' ') || item.information || '';
        if (/חינם/.test(source)) return 0;
        const match = source.match(/(\d[\d,]*(?:\.\d+)?)\s*(?:₪|ש["״]?ח)/) || source.match(/₪\s*(\d[\d,]*(?:\.\d+)?)/);
        return match ? Number(match[1].replaceAll(',', '')) : null;
      };
      for (const item of items) {
        item.base = firstCost(item);
        const tags = item.tags || [];
        let group = 'other';
        if (/^מזרן/.test(item.title)) group = 'mattresses';
        else if (/שידת לילה/.test(item.title)) group = 'stands';
        else if (/^מיטה |^מיטת /.test(item.title)) group = 'beds';
        else if (/^ארון/.test(item.title)) group = 'wardrobes';
        else if (tags.includes('פתרונות אירוח') || tags.includes('מוצרי גלריה') || tags.includes('כורסאות טלויזיה')) group = 'gallery';
        if (/לורנס/.test(item.title)) item.base = /סט/.test(item.variant) ? 300 : /קטן/.test(item.variant) ? 120 : /גדול/.test(item.variant) ? 250 : null;
        groups[group].push(item);
      }
      const quantity = group => group.reduce((sum, item) => sum + item.quantity, 0);
      let total = 0;
      let complete = true;
      const add = (label, value) => {
        if (value === null) complete = false;
        else total += value;
        rows.push({ label, value });
      };
      for (const item of groups.beds) add(`${item.title} — ${item.variant} × ${item.quantity}`, item.base === null ? null : item.base * item.quantity);
      const bedCount = quantity(groups.beds);
      if (bedCount > 1 && groups.beds.every(item => item.base !== null)) {
        add(this.querySelector('[data-delivery-discount]').textContent + ' (מיטות, 10%)', -groups.beds.reduce((sum, item) => sum + item.base * item.quantity, 0) * 0.1);
      }
      const dimension = item => (item.variant.match(/\d{2,3}\s*[\/x×]\s*\d{2,3}/) || [''])[0].replace(/\s/g, '');
      const pairedBeds = groups.beds.filter(item => /תוספת\s*למזרן\s*40/.test(item.information || ''));
      const pairedCount = quantity(pairedBeds);
      groups.mattresses.sort((a, b) => Number(pairedBeds.some(bed => dimension(bed) === dimension(b))) - Number(pairedBeds.some(bed => dimension(bed) === dimension(a))));
      let mattressIndex = 0;
      for (const item of groups.mattresses) {
        let value = 0;
        for (let unit = 0; unit < item.quantity; unit++, mattressIndex++) {
          if (mattressIndex < pairedCount) value += 40;
          else if (mattressIndex > 0) value += 90;
          else if (item.base !== null) value += item.base;
          else { value = null; break; }
        }
        add(`${item.title} — ${item.variant} × ${item.quantity}`, value);
      }
      if (quantity(groups.stands)) {
        const count = quantity(groups.stands);
        add(groups.stands.map(item => `${item.title} × ${item.quantity}`).join(', '), groups.stands.every(item => item.base === 99) ? (bedCount ? (count % 2 ? null : count / 2 * 100) : Math.ceil(count / 2) * 99) : null);
      }
      for (const name of ['wardrobes', 'gallery', 'other']) {
        const group = groups[name];
        for (const item of group) add(`${item.title} — ${item.variant} × ${item.quantity}`, item.base === null ? null : item.base * item.quantity);
        if (name !== 'other' && quantity(group) > 1 && group.every(item => item.base !== null)) {
          add(this.querySelector('[data-delivery-discount]').textContent + ' (10%)', -group.reduce((sum, item) => sum + item.base * item.quantity, 0) * 0.1);
        }
      }
      const result = complete ? money(Math.round(total * 100) / 100) : unknown;
      this.querySelector('[data-delivery-total]').textContent = result;
      this.querySelector('[data-delivery-modal-total]').textContent = result;
      const list = this.querySelector('[data-delivery-breakdown]');
      for (const row of rows) {
        const li = document.createElement('li');
        li.style.cssText = 'display:flex;justify-content:space-between;gap:16px;margin:10px 0';
        const label = document.createElement('span');
        label.textContent = row.label;
        const price = document.createElement('bdi');
        price.style.whiteSpace = 'nowrap';
        price.textContent = row.value === null ? unknown : money(row.value);
        li.append(label, price);
        list.append(li);
      }
      const dialog = this.querySelector('[data-delivery-dialog]');

      this.querySelector('[data-delivery-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => { if (this.isConnected) this.append(dialog); else dialog.remove(); });
    }
  });
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-delivery-open]');
    if (!opener) return;
    const element = opener.closest('slipi-cart-delivery');
    const dialog = element && element.querySelector('[data-delivery-dialog]');
    if (!dialog) return;
    event.preventDefault();
    document.body.append(dialog);
    dialog.showModal();
  }, true);
}

if (!window.slipiDeliveryCheckout) {
  window.slipiDeliveryCheckout = async () => {
    const root = window.Shopify.routes.root;
    const readCart = async () => {
      const response = await fetch(root + 'cart.js', { cache: 'no-store' });
      if (!response.ok) throw new Error('cart');
      return response.json();
    };
    const signature = items => JSON.stringify(items.map(item => [Number(item.variant_id), item.quantity]));
    const htmlResponse = await fetch(root + 'cart', { cache: 'no-store' });
    if (!htmlResponse.ok) throw new Error('quote');
    const parsed = new DOMParser().parseFromString(await htmlResponse.text(), 'text/html');
    const quote = parsed.querySelector('slipi-cart-delivery');
    if (!quote) throw new Error('empty');
    customElements.get('slipi-cart-delivery').prototype.connectedCallback.call(quote);
    const rendered = JSON.parse(quote.querySelector('[data-delivery-items]').textContent);
    let cart = await readCart();
    if (signature(cart.items) !== signature(rendered)) throw new Error('changed');
    const text = quote.querySelector('[data-delivery-total]').textContent + ' - לתשלום ישירות למובילים';
    const initialSignature = signature(cart.items);
    const propertyName = 'הובלה עבור כל הפריטים';
    const previousPropertyName = 'הובלה להזמנה';
    const anchor = cart.items.at(-1);
    const oldLines = cart.items.slice(0, -1).filter(item => item.properties && (Object.hasOwn(item.properties, propertyName) || Object.hasOwn(item.properties, previousPropertyName)));
    for (const line of [...oldLines, anchor]) {
      const properties = { ...line.properties };
      delete properties[previousPropertyName];
      if (line === anchor) properties[propertyName] = text;
      else {
        delete properties[propertyName];
        properties._slipi_delivery = '1';
      }
      if (JSON.stringify(properties) === JSON.stringify(line.properties)) continue;
      const response = await fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: line.key, quantity: line.quantity, properties })
      });
      if (!response.ok) throw new Error('save');
      cart = await response.json();
      if (signature(cart.items) !== initialSignature) throw new Error('changed');
    }
    cart = await readCart();
    if (signature(cart.items) !== initialSignature || cart.items.filter(item => item.properties?.[propertyName] === text).length !== 1) throw new Error('changed');
    return root + 'checkout';
  };
  const checkout = async button => {
    if (button.disabled) return;
    button.disabled = true;
    const scope = button.closest('main-cart, cart-drawer') || document;
    const error = scope.querySelector('.cart-terms-error');
    try {
      location.assign(await window.slipiDeliveryCheckout());
    } catch {
      button.disabled = false;
      if (error) {
        error.textContent = scope.querySelector('[data-delivery-checkout-error]')?.textContent || '';
        error.style.display = 'block';
      }
    }
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('.wd-cart-checkout-btn');
    if (!button || button.classList.contains('is-terms-disabled')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    checkout(button);
  }, true);
  document.addEventListener('submit', event => {
    const button = event.submitter;
    if (!button?.matches('.wd-cart-checkout-btn') || button.classList.contains('is-terms-disabled')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    checkout(button);
  }, true);
  if (new URLSearchParams(location.search).get('slipi_delivery_test') === '1') {
    const element = document.querySelector('main-cart slipi-cart-delivery') || document.querySelector('slipi-cart-delivery');
    if (element) {
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = 'בדיקת הובלה בצ׳ק אאוט';
      button.className = 'btn btn--primary';
      element.append(button);
      button.addEventListener('click', () => checkout(button));
    }
  }
}
